import React from 'react';
import {
  Box,
  Inline,
  PaddingSize,
} from '@styleseat/ui';

import { ISearchTile } from '../SearchTile/SearchTile.types';
import SearchTile from '../SearchTile/SearchTile';

export type SearchTileLineProps = {
  onPress?: (tile: ISearchTile) => void;
  tiles: ISearchTile[];
  imageHeight: number;
  imageWidth: number;
  space: PaddingSize;
};

/**
 * Displays a clickable image with text beneath
 */
export const SearchTilesLine = ({
  onPress = () => {},
  tiles,
  imageHeight,
  space,
  imageWidth,
}: SearchTileLineProps) => (
  <Inline space={space} style={{ margin: 'auto' }}>
    {tiles.map(tile => (
      <Box key={tile.text}>
        <SearchTile
          {...tile}
          imageHeight={imageHeight}
          imageWidth={imageWidth}
          onPress={() => onPress(tile)}
        />
      </Box>
    ))}
  </Inline>
);
